document.addEventListener('DOMContentLoaded', () => {
  if (typeof tarteaucitron == 'undefined') {
    return;
  }

  const responseAll = tarteaucitron.userInterface.respondAll;
  tarteaucitron.userInterface.respondAll = function (status) {
    responseAll(status);

    const mainPopin = document.getElementById('tarteaucitron');
    if ((mainPopin && mainPopin.style.display === 'block') || !status) {
      return;
    }

    window.location.reload();
  };

  tarteaucitron.userInterface.respond = (el, status) => {
    "use strict";

    tarteaucitron.reloadThePage = true;

    if (el.id === "") {
      return;
    }
    var key = el.id.replace(new RegExp("(Eng[0-9]+|Allow|Deni)ed", "g"), "");

    if (key.substring(0, 13) === "tarteaucitron" || key === "") {
      return;
    }

    // return if same state
    if (tarteaucitron.state[key] === status) {
      return;
    }

    if (status === false && tarteaucitron.launch[key] === true) {
      tarteaucitron.reloadThePage = true;
    }

    // if not already launched... launch the service
    if (status === true) {
      if (tarteaucitron.launch[key] !== true) {

        tarteaucitron.pro("!" + key + "=engage");

        tarteaucitron.launch[key] = true;
        tarteaucitron.sendEvent(key + "_loaded");
        if (
          typeof tarteaucitronMagic === "undefined" ||
          tarteaucitronMagic.indexOf("_" + key + "_") < 0
        ) {
          tarteaucitron.services[key].js();
        }
      }
    }
    tarteaucitron.state[key] = status;
    tarteaucitron.cookie.create(key, status);
    tarteaucitron.userInterface.color(key, status);

    const panel = document.getElementById('tarteaucitron');

    if (panel.style.display !== 'block') {
      tarteaucitron.userInterface.closePanel();
    }
  }

  const cookiePreferenceSelectors = [...document.querySelectorAll('.edit-cookies-preferences')];
  cookiePreferenceSelectors.forEach(selector => {
    selector.addEventListener('click', event => {
      event.preventDefault ? event.preventDefault() : (event.returnValue = false);
      tarteaucitron.userInterface.openPanel();
    });
  });

  const recaptchaJs = tarteaucitron.services.recaptcha.js;
  tarteaucitron.services.recaptcha.js = function () {
    const bodyElement = document.querySelector('body');
    if (bodyElement.hasAttribute('data-tacjs-recaptcha')) {
      return;
    }
    bodyElement.setAttribute('data-tacjs-recaptcha', true);

    recaptchaJs();
  };

  const recaptchaFallback = tarteaucitron.services.recaptcha.fallback;
  tarteaucitron.services.recaptcha.fallback = function () {
    const bodyElement = document.querySelector('body');
    if (bodyElement.hasAttribute('data-tacjs-recaptcha')) {
      return;
    }
    bodyElement.setAttribute('data-tacjs-recaptcha', true);

    recaptchaFallback();
  };
});
